import React from 'react'
import { FormGroup, FormFeedback, Label } from 'reactstrap'
import { InputMask } from 'primereact/inputmask'
import PropTypes from 'prop-types'

export default function CustomNumberFormat({
  onChange,
  name,
  label,
  value,
  type,
  placeholder,
  autoComplete,
  readOnly,
  invalid,
  errorMess,
  className,
  disabled,
  formClassName,
  isNumericString,
  format,
  size,
  hidePhoneIcon,
}) {
  return (
    <FormGroup className={formClassName}>
      {label ? <Label>{label}</Label> : null}
      <InputMask
        className={className}
        onChange={onChange}
        name={name}
        readOnly={readOnly}
        hidePhoneIcon={hidePhoneIcon}
        value={value || ''}
        type={type}
        placeholder={placeholder}
        autoComplete={autoComplete}
        invalid={invalid}
        // bsSize='m'
        disabled={disabled}
        isNumericString={isNumericString}
        mask={format}
        size={size}
      />
      <FormFeedback style={{ marginBottom: '-20px' }}>{errorMess}</FormFeedback>
    </FormGroup>
  )
}

CustomNumberFormat.propTypes = {
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  removeLabel: PropTypes.bool,
  autoComplete: PropTypes.string,
  errorMess: PropTypes.string,
  className: PropTypes.string,
  isNumericString: PropTypes.bool,
  // isNumericString: PropTypes.string,
}

CustomNumberFormat.defaultProps = {
  readOnly: false,
}
